<template>
  <div id="app">
    <div class="game" :class="gamestate" :data-bg="nextColor">
      <div class="countdown-text">
        <h3>Ready</h3>
        <h3>Set</h3>
        <h3>Go</h3>
      </div>

      <div class="intro-hint" v-if="highscore <= 1 && score < 3">
        Tap the color in the BEAM!
      </div>

      <div class="score">
        {{score}}
      </div>

      <div class="highscore">
        {{highscore}}
      </div>

      <div class="beam-fx">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="enemy-box">
        <div class="enemy"></div>
        <div class="top half">
          <div class="side-beam anim"></div>
        </div>
        <div class="bottom half">
          <div class="side-beam anim"></div>
        </div>
      </div>

      <div class="bg-color bg-red"></div>
      <div class="bg-color bg-green"></div>
      <div class="bg-color bg-blue"></div>
      <div class="bg-color bg-white"></div>
    </div>

    <div class="start" @touchend="startGame"></div>

    <Controls @shootColor="shootColor" :gamestate=gamestate />

    <div class="leaderboard" v-if="scoreboard">
      <fieldset v-if="!justsubmit && newhighscore">
        <input type="text" placeholder="AAA" maxlength=3 v-model="abbr" />
        <button @click="submitScore">Submit</button>
      </fieldset>

      <h2>High Scores</h2>
      <ul>
        <li v-for="score in scoreboard" :key="score.abbr + score.time">
          {{score.abbr}} ......... {{score.score}}
        </li>
      </ul>

      <button @touchend="shootColor(true)">Restart</button>
    </div>
  </div>
</template>

<script>
import store from 'store';
import * as firebase from 'firebase/app';
import 'firebase/database';
import Controls from './components/Controls.vue';

export default {
  name: 'app',
  data() {
    return {
      colors: ['red', 'blue', 'green', 'white'],
      start: false,
      score: 0,
      highscore: 0,
      gamestate: false,
      db: null,
      scoreboard: false,
      abbr: null,
      justsubmit: false,
      nextColor: false,
    };
  },
  computed: {
    newhighscore() {
      return (this.scoreboard) ? this.scoreboard[9].score <= this.score : false;
    },
  },
  components: {
    Controls,
  },
  mounted() {
    if (store.get('highscore')) this.highscore = store.get('highscore');

    // firebase
    const config = {
      apiKey: 'AIzaSyCwqTFuv-lJiCl-6k70ftT9oAFraq4njsQ',
      authDomain: 'imprism-9a7d3.firebaseapp.com',
      databaseURL: 'https://imprism-9a7d3.firebaseio.com',
      projectId: 'imprism-9a7d3',
      storageBucket: 'imprism-9a7d3.appspot.com',
      messagingSenderId: '1091131620426',
    };

    firebase.initializeApp(config);
    this.db = firebase.database();
  },
  methods: {
    startGame() {
      this.shootColor();
    },
    shootColor(c) {
      // Start the game
      if (!this.start) {
        this.start = true;
        this.score = 0;
        this.changeBeam();

        this.$anime({
          targets: '.countdown-text h3:first-child',
          translateX: '-100%',
          opacity: 0,
          duration: 2000 / 3,
          easing: 'easeInQuad',
          autoplay: true,
        });

        this.$anime({
          targets: '.countdown-text h3:nth-child(2)',
          translateX: '-100%',
          opacity: 0,
          delay: 750,
          duration: 2000 / 3,
          easing: 'easeInQuad',
          autoplay: true,
        });

        this.$anime({
          targets: '.countdown-text h3:last-child',
          translateX: '-100%',
          scale: 2,
          opacity: 0,
          delay: 1500,
          duration: 2000 / 3,
          easing: 'easeInQuad',
          autoplay: true,
        });
      } else {
        // Or if it is already underway

        // If we match the color
        const gameEl = document.querySelector('.game');

        this.$anime.remove('.top .side-beam');
        this.$anime.remove('.bottom .side-beam');

        if (c === this.convertColor(gameEl.style.getPropertyValue('--beam-color'))) {
          this.changeBeam();
          this.score += 1;
          if (window.navigator.vibrate) window.navigator.vibrate(50);
        } else {
          if (window.navigator.vibrate) window.navigator.vibrate(300);
          this.endGame();
        }
      }
    },
    randomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    changeBeam() {
      this.gamestate = !this.gamestate || this.gamestate === 'end' ? 'countdown' : 'playing';
      const gameEl = document.querySelector('.game');
      const nextColor = this.nextColor; // eslint-disable-line
      const cColor = this.convertColor(nextColor);
      const fColor = this.colors.filter(c => c !== cColor);

      gameEl.style.setProperty('--beam-color', nextColor);
      this.nextColor = this.convertColor(fColor[this.randomInt(this.colors.length - 1)]);

      const scoreDur = Math.floor(this.score / 20) * 200;
      this.$anime({
        targets: '.top .side-beam',
        rotate: ['45deg', 0],
        scaleX: 1.5,
        translateY: '5vh',
        duration: this.score >= 20 ? 2000 - scoreDur : 2000,
        easing: 'easeOutQuad',
        autoplay: true,
      });

      const beam = this.$anime({
        targets: '.bottom .side-beam',
        rotate: ['-45deg', 0],
        scaleX: 1.5,
        translateY: '-5vh',
        duration: this.score >= 20 ? 2000 - scoreDur : 2000,
        easing: 'easeOutQuad',
        autoplay: true,
      });

      const beamSpeed = `${Math.floor(this.score / 25) + 1}px`;
      gameEl.style.setProperty('--beam-speed', beamSpeed);
      gameEl.style.setProperty('--neg-beam-speed', `-${beamSpeed}`);

      beam.complete = () => {
        if (this.gamestate === 'playing') {
          this.endGame();
        } else {
          this.changeBeam();
        }
      };
    },
    submitScore() {
      this.justsubmit = true;

      this.db.ref('highscore').push({
        score: this.score,
        abbr: (this.abbr) ? this.abbr.toUpperCase() : 'AAA',
        time: Date.now(),
      });

      this.getLeaderboard();
    },
    getLeaderboard() {
      try {
        this.db.ref('highscore').orderByChild('score').limitToLast(10).once('value', (data) => {
          this.scoreboard = [];
          data.forEach((player) => {
            this.scoreboard.unshift(player.val());
          });
        });
      } catch (e) {
        console.log(e);
      }
    },
    endGame() {
      // Set states
      this.start = false;
      this.gamestate = 'end';
      this.justsubmit = false;

      // Save highscore, if higher than last
      if (this.score > this.highscore) {
        this.highscore = this.score;
        store.set('highscore', this.score);
      }

      // Update UI
      document.querySelector('.game').removeAttribute('style');
      document
        .querySelectorAll('.countdown-text h3')
        .forEach(heading => heading.removeAttribute('style'));

      // Load scores from Firebase
      this.getLeaderboard();
    },
    convertColor(c) {
      // Get keyword
      if (c && c.startsWith('#')) {
        switch (c) {
          case '#18a8f0':
            return 'blue';
          case '#58F048':
            return 'green';
          case '#f04848':
            return 'red';
          default:
            return 'white';
        }
      } else {
        // Get hex
        switch (c) {
          case 'blue':
            return '#18a8f0';
          case 'green':
            return '#58F048';
          case 'red':
            return '#f04848';
          default:
            return '#FFFFFF';
        }
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  background: #000;
  font-family: 'Calibri', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  margin: 0 auto;
  //max-width: 65vh;
  overflow: hidden;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100vh;
}

:root {
  --beam-color: transparent;
  --beam-speed: 1px;
  --beam-speed: -1px;
}

.start {
  background: white url(assets/cover.svg) no-repeat center center;
  background-size: auto 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.2s;
  width: 100%;
  z-index: 99;

  :not([class='game']) + & {
    transform: translateY(100%);
  }

  @media (pointer: fine) {
    background: #f04848;
    color: white;
    display: flex;
    transform: translateY(0) !important;

    &:before {
      content: 'Imprism is meant to be played on your 📱!';
      font-size: 2em;
      margin: auto;
      max-width: 300px;
    }
  }
}

.intro-hint {
  background: orange;
  color: white;
  padding: 3px 0;
}

@keyframes pulse {
  from {
    filter: grayscale(0.9);
  }
  to {
    filter: grayscale(0);
  }
}

.game {
  background: #000;
  height: 40vh;
  overflow: hidden;
  position: relative;
  z-index: 1;

  .bg-color {
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    transition: opacity 0.5s;
    will-change: opacity;
    width: 100%;
    z-index: -1;

    &.bg-red { background: #f04848; }
    &.bg-green { background: #58f048; }
    &.bg-blue { background: #18a8f0; }
    &.bg-white { background: #FFF; }
  }

  &[data-bg="#f04848"] .bg-red { opacity: 1; }
  &[data-bg="#58F048"] .bg-green { opacity: 1; }
  &[data-bg="#18a8f0"] .bg-blue { opacity: 1; }
  &[data-bg="#FFFFFF"] .bg-white { opacity: 1; }

  &.end {
    --beam-color: transparent;

    .bg-color {
      opacity: 0;
    }

    ~ .controls {
      transform: translateY(110%);

      button {
        filter: grayscale(0.9);

        &[data-color='green'] {
          animation: pulse 1s infinite alternate;
        }
      }
    }
  }
}

.countdown-text {
  color: transparent;
  font-size: 2em;
  padding-left: 20px;
  position: absolute;
  top: 23%;
  text-align: left;

  .countdown & {
    color: white;
  }
}

.score {
  color: white;
  font-size: 120px;
  line-height: 27vh;
  opacity: 1;
  pointer-events: none;
  position: absolute;
  top: 0;
  text-align: center;
  transition: 0.25s transform;
  width: 100%;
  z-index: 1;

  .game:not(.end) & {
    line-height: 40vh;
    transform: scale(0.25) translate(140%, -160%);
    text-align: right;
  }
}

.highscore {
  color: white;
  opacity: 0.5;
  pointer-events: none;
  position: absolute;
  bottom: 10px;
  right: 10px;
  transition: 0.5s opacity;
  z-index: 1;

  &:before {
    content: 'Best: ';
  }
  .playing & {
    opacity: 0;
  }
}

.leaderboard {
  align-items: center;
  background: white;
  bottom: 0;
  display: flex;
  flex-direction: column;
  font-family: 'Courier New', Courier, monospace;
  height: 73vh;
  padding: 20px 0 40px;
  position: fixed;
  transition: transform 0.3s ease-in;
  width: 100%;
  z-index: 1;

  ul {
    list-style: none;
    padding: 5px 0;
    text-align: left;
  }

  fieldset {
    border: 0 none;
    margin-bottom: 10px;
  }

  input {
    font-size: 1.5em;
    height: 40px;
    margin-right: 5px;
    padding: 0 5px;
    text-transform: uppercase;
    width: 100px;
    vertical-align: middle;
  }

  button {
    background: #18a8f0;
    border: 0 none;
    border-radius: 5px;
    box-shadow: 0 5px 0 darken(#18a8f0, 10%);
    color: white;
    padding: 12px 15px;
    vertical-align: middle;
  }

  .game:not(.end) ~ & {
    transform: translateY(100%);
  }
}

@keyframes pew {
  from {
    transform: none;
  }
  to {
    transform: translateX(200%);
  }
}

.beam-fx {
  height: 100%;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;

  .playing & {
    opacity: 1;
  }

  span {
    animation: pew 0.25s infinite;
    border-top: 1px solid var(--beam-color);
    display: block;
    position: relative;
    width: 100px;

    &:first-child {
      animation-delay: 0.2s;
      animation-duration: 0.15s;
      top: 10%;
    }

    &:nth-child(2) {
      animation-delay: 0.5s;
      top: 35%;
      left: 25%;
      width: 80px;
    }

    &:nth-child(3) {
      animation-duration: 0.2s;
      top: 60%;
      left: 45%;
      width: 50px;
    }

    &:nth-child(4) {
      animation-delay: 0.1s;
      top: 80%;
      left: 25%;
    }
  }


}

@keyframes hover {
  from {
    transform: none;
  }
  to {
    transform: translateY(-8px);
  }
}

@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(var(--neg-beam-speed), 0, 0);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translate3d(var(--beam-speed), 0, 0);
  }
}

.enemy {
  background: url(./assets/tri.png) no-repeat;
  background-size: contain;
  height: 20vh;
  width: 20vh;
  position: absolute;
  top: 10vh;
  right: 0;
  transition: transform 1s, opacity 1s;
  z-index: 1;

  .game:not(.countdown):not(.playing) & {
    opacity: 0;
    transform: translateX(200%) rotate(-15deg);
  }
}

.enemy-box {
  animation: hover 0.5s ease-in infinite alternate;
  //border: 1px dotted #333;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  width: 95vw;

  .game.playing & {
    animation-name: shake;
  }

  .countdown & .half { opacity: 0; }

  .half {
    flex-grow: 1;
    mix-blend-mode: overlay;
    overflow: hidden;
    will-change: transform;
    width: 100%;
    z-index: 2;

    &.top {
      .side-beam {
        border-top-right-radius: 35%;
        //transform: rotate(45deg);
        transform-origin: right top;
        top: 10vh;
        position: relative;
      }
    }

    &.bottom {
      .side-beam {
        border-bottom-right-radius: 35%;
        //transform: rotate(-45deg);
        transform-origin: right bottom;
        top: -40vh;
        position: relative;
      }
    }
  }

  .side-beam {
    background: var(--beam-color);
    height: 50vh;
    width: 100%;
  }
}
</style>
